<template>
    <div :class="['news-item', { 'flex-row': direction === 'row' }, { 'flex-col': direction === 'col' }]"
        @click="toDetails(item)">
        <div :class="['news-item-img', imgSize]" v-if="showImg && item.newsImage">
            <img :src="item.newsImage" alt="news-item-img" />
        </div>
        <div class="news-item-info">
            <div class="news-item-title">{{ item.newsTitle }}</div>
            <div class="news-item-content">{{ item.brief }}</div>
            <div class="news-item-type">
                {{ item.newstype }}
                <span>{{ item.newstype && item.tag ? ' · ' : '' }} {{ item.tag }}</span>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'NewsItem',
    props: {
        item: {
            type: Object,
            required: true
        },
        direction: {
            type: String,
            default: 'row'
        },
        showImg: {
            type: Boolean,
            default: true
        },
        imgSize: {
            type: String,
            default: 'middle'
        }
    },
    methods: {
        toDetails(item, url) {
            if (url) {
                window.open(url, "_blank");
            } else {
                if (item.price == 0) {
                    //存储 newsId
                    localStorage.setItem('newsId', item.newsId);
                    let path = item.seoUrl ? item.seoUrl : item.newsId
                    this.$router.push({
                        path: `/${path}.html`,
                    });
                } else {
                    this.$router.push({
                        path: `/expert-details/${item.newsId}`,
                    });
                }
            }
        },
        generateSlug(title) {
            // 将标题中的空格替换为连字符
            let slug = title.toLowerCase().replace(/\s+/g, '-');
            // 将连字符替换为单个连字符
            slug = slug.replace(/-+/g, '');
            slug = slug.replace(/:+/g, '');
            return slug;
        },
    }
}
</script>

<style lang="less" scoped>
.news-item {
    padding: 10px 0;
    width: 100%;
    height: 100%;
    background-color: #fff;
    cursor: pointer;

    .news-item-img {
        width: 100%;
        height: 100%;

        img {
            width: 100%;
            height: 100%;
            max-height: 507px;
            object-fit: cover;
            border-radius: 8px;
        }
    }

    .big {
        width: 100%;
        height: 507px !important;
    }

    .middle {
        width: 100%;
        height: 244px !important;
    }

    .middle2 {
        width: 100%;
        height: 218px !important;
    }

    .small {
        width: 100%;
        height: 128px !important;
    }


    .news-item-info {
        .news-item-title {
            font-family: MicrosoftYaHei, MicrosoftYaHei;
            font-weight: bold;
            font-size: 24px;
            color: #2C2C2E;
            line-height: 31px;
            text-align: left;
            font-style: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .news-item-content {
            font-family: MicrosoftYaHei;
            font-size: 16px;
            color: #636366;
            line-height: 21px;
            text-align: justify;
            font-style: normal;
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
        }

        .news-item-type {
            font-family: MicrosoftYaHei;
            font-size: 14px;
            color: #E2291E;
            line-height: 19px;
            text-align: left;
            font-style: normal;
            margin-top: 8px;

            span {
                color: #636366;
            }
        }
    }

    &:hover {
        .news-item-title {
            color: #E2291E;
        }
    }
}

.flex-row {
    .news-item-img {
        width: 200px;
        height: 128px;
        margin-right: 16px;

        img {
            width: 200px;
            height: 128px;
            object-fit: cover;
            border-radius: 8px;
        }
    }
}

.flex-col {
    .news-item-img {
        width: 100%;
        max-height: 507px;
        margin-bottom: 16px;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
            border-radius: 8px;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/views/common/news-item.vue